import { ReactComponent as More } from '../../assets/icons/more.svg'
import { ReactComponent as Orders } from '../../assets/icons/orders.svg'
import { ReactComponent as Packaging } from '../../assets/icons/packaging.svg'
import { ReactComponent as Growth } from '../../assets/icons/growth.svg'
import { ReactComponent as Service } from '../../assets/icons/services.svg'
import { ReactComponent as Shop } from '../../assets/icons/shop.svg'
import { ReactComponent as Start } from '../../assets/icons/start.svg'
import { token } from '../../util/constants'
import {
  clearStateFn,
  deleteCookie,
  loadStateFn,
} from '../../util/localStorage'
import {
  railsBulkOrdersUrl,
  performSignOut,
  railsCreativeServicesUrl,
  railsCustomLabelsUrl,
  railsCustomProductsUrl,
  railsGetSalesUrl,
  railsInvoicesUrl,
  railsMediaPackagesHistoryUrl,
  railsMediaPackagesUrl,
  railsOrdersUrl,
  railsPackagingUrl,
  railsProductsUrl,
  railsSettingsUrl,
  railsStoreSetupUrl,
} from '../../util/railsAuth'

const HELP_CENTER_URL = 'https://intercom.help/dripshipper-help/en/'

const PRIVACY_POLICY_URL =
  'https://intercom.help/dripshipper-help/en/articles/5812233-privacy-policy'

const BULK_ORDERS_PATH =
  railsBulkOrdersUrl(loadStateFn(token)) || '/direct-and-bulk-orders'

const ORDERS_PATH = railsOrdersUrl(loadStateFn(token)) || '/orders'

const INVOICES_PATH = railsInvoicesUrl(loadStateFn(token)) || '/invoices'

const GET_SALES_PATH = railsGetSalesUrl(loadStateFn(token)) || '/get-sales'

const STORE_SETUP_PATH =
  railsStoreSetupUrl(loadStateFn(token)) || '/purchase-turnkey-store'

const CREATIVE_SERVICES_PATH =
  railsCreativeServicesUrl(loadStateFn(token)) || '/creative-services'

const MEDIA_PACKAGES_PATH =
  railsMediaPackagesUrl(loadStateFn(token)) || '/purchase-media-packages'

const MEDIA_PACKAGES_HISTORY_PATH =
  railsMediaPackagesHistoryUrl(loadStateFn(token)) || '/media-packages-history'

const SETTINGS_PATH = railsSettingsUrl(loadStateFn(token)) || '/settings'

export const sideBarMenuList = [
  { name: 'Getting Started', icon: Start, to: '/getting-started' },
  { name: 'Connect Store', icon: Shop, to: '/connect-store' },
  {
    name: 'Products',
    icon: Packaging,
    children: [
      {
        name: 'Packaging',
        to: railsPackagingUrl(loadStateFn(token)) || '/packaging',
        isMonolith: true,
      },
      {
        name: 'Products',
        to: railsProductsUrl(loadStateFn(token)) || '/products',
        isMonolith: true,
      },
      {
        name: 'Custom Labels',
        to: railsCustomLabelsUrl(loadStateFn(token)) || '/custom-labels',
        isMonolith: true,
      },
      {
        name: 'My Custom Products',
        to: railsCustomProductsUrl(loadStateFn(token)) || '/my-custom-products',
        isMonolith: true,
      },
      { name: 'Bulk Orders', to: BULK_ORDERS_PATH, isMonolith: true },
    ],
  },
  {
    name: 'Orders',
    icon: Orders,
    children: [
      { name: 'Orders', to: ORDERS_PATH, isMonolith: true },
      { name: 'Invoices', to: INVOICES_PATH, isMonolith: true },
      { name: 'Bulk Orders', to: BULK_ORDERS_PATH, isMonolith: true },
    ],
  },
  {
    name: 'Growth',
    icon: Growth,
    children: [
      {
        name: 'Get Sales',
        to: GET_SALES_PATH,
        isMonolith: true,
      },
      { name: 'Launch Ads', to: '/launch-ads' },
    ],
  },
  {
    name: 'Services',
    icon: Service,
    menuKey: 'services',
    children: [
      {
        name: 'Services',
        menuKey: 'services_catalog',
        children: [
          {
            name: 'Store Setup',
            to: STORE_SETUP_PATH,
            isMonolith: true,
          },
          {
            name: 'Creative Services',
            to: CREATIVE_SERVICES_PATH,
            isMonolith: true,
          },
          {
            name: 'Media Packages',
            to: MEDIA_PACKAGES_PATH,
            isMonolith: true,
          },
          {
            name: 'Transaction History',
            to: MEDIA_PACKAGES_HISTORY_PATH,
            isMonolith: true,
          },
        ],
      },
      { name: 'Bulk Orders', to: BULK_ORDERS_PATH, isMonolith: true },
    ],
  },
  {
    name: 'More',
    icon: More,
    children: [
      { name: 'Settings', to: SETTINGS_PATH, isMonolith: true },
      { name: 'Help Center', to: HELP_CENTER_URL, isLink: true, newTab: true },
      {
        name: 'Privacy Policy',
        to: PRIVACY_POLICY_URL,
        isLink: true,
        newTab: true,
      },
      {
        name: 'Log out',
        type: 'button',
        onClick: () => performSignOut(clearStateFn, deleteCookie),
      },
    ],
  },
]
